import React, { Component }  from 'react';
import { Modal, Row, Col, Input, Icon } from 'antd';

class NewModal extends Component {
    // 确认设置引导语
    handleOk = () => {
        const { onOkSetGuide } = this.props;
        onOkSetGuide && onOkSetGuide();
    }

    // 取消设置引导语
    handleCancel = () => {
        const { onCancelSetGuide } = this.props;
        onCancelSetGuide && onCancelSetGuide();
    }

    // 修改分类内容
    onClassifyChange = (e, index) => {
        const { onClassifyChange } = this.props;
        onClassifyChange && onClassifyChange(e, index)
    }

    // 修改子分类的内容
    onGuideCntChange = (e, pIndex, cIndex, diff) => {
        const { onGuideCntChange } = this.props;
        onGuideCntChange && onGuideCntChange(e, pIndex, cIndex, diff)
    }

    // 新增/减少分类
    onPChassifyChange = (index, diff) => {
        const { onPChassifyChange } = this.props;
        onPChassifyChange && onPChassifyChange(index, diff)
    }

    // 增加/减少子分类
    onCChassifyChange = (pIndex, cIndex, diff) => {
        const { onCChassifyChange } = this.props;
        onCChassifyChange && onCChassifyChange(pIndex, cIndex, diff)
    }

    render() {
        const { isSetDefaultGuide, guideList } = this.props;
        return (
            <Modal
                title="添加引导语"
                className="guide-modal"
                style={{width: '560px'}}
                visible={isSetDefaultGuide}
                cancelText="取消"
                okText="确认"
                onOk={this.handleOk}
                onCancel={this.handleCancel}
            >
                <div className="init-default-guide">
                    {
                        guideList.map((item, index) => 
                            <div className="guide-language" key={index}>
                                <Row className="guide-language-row" type="flex" align="middle">
                                    <Col className="classify-name" span={3}>{`分类${index+1}：`}</Col>
                                    <Col className="classify-input" span={9}>
                                        <Input type="text" value={item.content}  onChange={(e) => this.onClassifyChange(e, index)}/>
                                    </Col>
                                    <Col className="classify-icon" span={4}>
                                        <Icon type="plus-circle-o" onClick={() => this.onPChassifyChange(index, 'add')} />
                                        <Icon type="minus-circle-o" onClick={() => this.onPChassifyChange(index, 'remove')} />
                                    </Col>
                                </Row>
                                {
                                    item.list.length > 0 && item.list.map( (innerItem, key) => 
                                    <Row className="guide-language-row" type="flex" align="middle" key={key} >
                                        <Col className="content-name" span={3}>{`内容${key+1}：`}</Col>
                                        <Col className="content-input" span={4}>
                                            <Input type="text" value={innerItem.key_words} placeholder="关键词" onChange={(e) => this.onGuideCntChange(e, index, key, 'key_words')}/>
                                        </Col>
                                        <Col className="content-input-large" span={13}>
                                            <Input type="text" value={innerItem.content} onChange={(e) => this.onGuideCntChange(e, index, key, 'content')}/>
                                        </Col>
                                        <Col className="content-icon" span={4}>
                                            <Icon type="plus-circle-o" onClick={() => this.onCChassifyChange(index, key, 'add')} />
                                            <Icon type="minus-circle-o" onClick={() => this.onCChassifyChange(index, key, 'remove')} />
                                        </Col>
                                    </Row>
                                   )
                                    
                                }
                                
                            </div>   
                        )
                    }
                </div>
            </Modal>
        )
    }
}

export default NewModal;


// WEBPACK FOOTER //
// ./src/entry_app/question_manage/question_tml/components/modal.js